sk_i18n = {
    ready: false,
    backlink: 'Terug',
    name: 'Naam',
    email: 'E-mailadres',
    message: 'Bericht',
	msgAlertCopy: '----------------------------\nLET OP\n----------------------------\nDoor deze pop-up te sluiten, kopieer je jouw kortingscode die begint met ',
	msgAlertCopyFooter: '\n\nZodra de volledige kortingscode naar jouw klembord is gekopieerd, wordt je direct doorgestuurd naar de website waar je deze korting kunt verzilveren.',
	msgAlertShare: 'Deze link is gekopieerd: ',
    msgNoCaptcha: 'Je dient aan te geven dat je geen robot bent!',
    msgContactSendTitle: 'Bedankt voor je bericht!',
    msgContactSendContent: 'Jouw bericht is succesvol verzonden. Wij zullen je zo spoedig als mogelijk beantwoorden.',
	msgWinName: 'Jouw volledige naam',
    msgWinEmail: 'Jouw studenten e-mailadres',
    msgWinMessage: 'Waarom moet jij winnen?',
	msgWinVraag: 'Wanneer werd de eerste Teufel webshop opgericht?',
	msgWinSendTitle: 'Leuk dat je meedoet met onze winactie!',
    msgWinSendContent: 'We houden je op de hoogte via onze nieuwsbrief. Zorg dus dat je bent aangemeld!',
	msgWinSendAlert: '----------------------------\nOoooops\n----------------------------\nOm mee te kunnen doen met onze winactie, moet je akkoord gaan met de winactie voorwaarden.',	
    msgWelcomeBack: "Welkom terug",
    msgNewsletterAlmostThere: "je bent er bijna!",
    msgNewsletterConfirmationMail: "Zojuist hebben we je een bevestigingsmail gestuurd (dit kan enkele minuten duren). Klik op de bevestigingslink in deze mail en vanaf dat moment ontvang jij leuke studentenkortingen via de e-mail :)",
    msgNewsletterSmartStudent: "jij bent echt een slimme student!",
    msgNewsletterSubscribed: "Vanaf nu ontvang jij leuke studentenkortingen via de e-mail.",
    msgBookboonDowloadStart:  'een ogenblik geduld, jouw download word binnen enkele seconden gestart. Veel plezier met je gratis studieboek!',
    msgBookboonSubscribed: 'Je kunt bijna jouw studieboek downloaden! Zojuist hebben we je een bevestigingsmail gestuurd (dit kan enkele minuten duren). Klik op de bevestigingslink in de mail. Je bent dan direct aangemeld voor onze nieuwsbrief en we zullen je dan doorsturen naar de pagina waar jij je ebook kunt downloaden. Klik op deze pagina wederom op de download button en jouw download wordt gestart. Veel plezier met je gratis studieboek!',
    msgFetchingCode: 'Je code wordt gegenereerd',
    msgFetchingCodeFailed: 'Oeps! Genereren van code mislukt',
	msgFailedCopyDiscountCode: '----------------------------\nOoooops\n----------------------------\nHelaas kunnen we de kortingscode niet naar jouw klembord kopiëren, omdat je browser geen toestemming heeft om tekst te kopiëren. Geef via browser-instellingen toestemming of probeer het opnieuw in een andere browser.'
};

$(document).ready(function() {
    if ($('body').is('.lang_en') || $('body').is('.lang_uk')) {
        sk_i18n = {
            ready: true,
            backlink: 'Previous',
            name: 'Full name',
            email: 'E-mail address',
            message: 'Your message',
			msgAlertCopy: '----------------------------\nATTENTION\n----------------------------\nBy closing this pop-up, you will copy your discount code starting with ',
			msgAlertCopyFooter: '\n\nOnce the entire discount code has been copied to your clipboard, you will be redirected directly to the website where you can redeem this discount.',
			msgAlertShare: 'This link has been copied: ',
            msgNoCaptcha: 'Please indicate that you are not a robot!',
            msgContactSendTitle: 'Thanks for your message!',
            msgContactSendContent: 'Your message has been sent successfully. We will answer you as soon as possible.',
			msgWelcomeBack: "Welcome back",
			msgNewsletterAlmostThere: "you're almost there!",
			msgNewsletterConfirmationMail: "We just sent you a confirmation email (this may take a few minutes). Click on the confirmation link and you will receive interesting student discounts per email :)",
			msgNewsletterSmartStudent: "you are a smart student!",
			msgNewsletterSubscribed: "From now on you will receive interesting student discounts per email.",
            msgFetchingCode: 'Your code is being generated',
            msgFetchingCodeFailed: 'Oops! Generating code failed',
			msgFailedCopyDiscountCode: '----------------------------\nOoooops\n----------------------------\nUnfortunately, we can\'t copy the discount code to your clipboard because your browser doesn\'t have permission to copy text. Please enable permission in your browser settings, or try a different browser.'
        };
    }
	else if ($('body').is('.lang_us')) {
        sk_i18n = {
            ready: true,
            backlink: 'Previous',
            name: 'Full name',
            email: 'E-mail address',
            message: 'Your message',
			msgAlertCopy: '----------------------------\nATTENTION\n----------------------------\nBy closing this pop-up, you will copy your coupon code starting with ',
			msgAlertCopyFooter: '\n\nOnce the entire coupon code is copied to your clipboard, you will be redirected directly to the website where you can redeem this discount.',
			msgAlertShare: 'This link has been copied: ',
            msgNoCaptcha: 'Please indicate that you are not a robot!',
            msgContactSendTitle: 'Thanks for your message!',
            msgContactSendContent: 'Your message has been sent successfully. We will answer you as soon as possible.',
			msgWelcomeBack: "Welcome back",
			msgNewsletterAlmostThere: "you're almost there!",
			msgNewsletterConfirmationMail: "We just sent you a confirmation email (this may take a few minutes). Click on the confirmation link and you will receive interesting student discounts per email :)",
			msgNewsletterSmartStudent: "you are a smart student!",
			msgNewsletterSubscribed: "From now on you will receive interesting student discounts per email.",
            msgFetchingCode: 'Your code is being generated',
            msgFetchingCodeFailed: 'Oops! Generating code failed',
            msgFailedCopyDiscountCode: '----------------------------\nOoooops\n----------------------------\nUnfortunately, we can\'t copy the coupon code to your clipboard because your browser doesn\'t have permission to copy text. Please enable permission in your browser settings, or try a different browser.'
        };
    }
	else if ($('body').is('.lang_ca')) {
        sk_i18n = {
            ready: true,
            backlink: 'Previous',
            name: 'Full name',
            email: 'E-mail address',
            message: 'Your message',
			msgAlertCopy: '----------------------------\nATTENTION\n----------------------------\nBy closing this pop-up, you will copy your coupon code starting with ',
			msgAlertCopyFooter: '\n\nOnce the entire coupon code is copied to your clipboard, you will be redirected directly to the website where you can redeem this discount.',
			msgAlertShare: 'This link has been copied: ',
            msgNoCaptcha: 'Please indicate that you are not a robot!',
            msgContactSendTitle: 'Thanks for your message!',
            msgContactSendContent: 'Your message has been sent successfully. We will answer you as soon as possible.',
			msgWelcomeBack: "Welcome back",
			msgNewsletterAlmostThere: "you're almost there!",
			msgNewsletterConfirmationMail: "We just sent you a confirmation email (this may take a few minutes). Click on the confirmation link and you will receive interesting student discounts per email :)",
			msgNewsletterSmartStudent: "you are a smart student!",
			msgNewsletterSubscribed: "From now on you will receive interesting student discounts per email.",
            msgFetchingCode: 'Your code is being generated',
            msgFetchingCodeFailed: 'Oops! Generating code failed',
            msgFailedCopyDiscountCode: '----------------------------\nOoooops\n----------------------------\nUnfortunately, we can\'t copy the coupon code to your clipboard because your browser doesn\'t have permission to copy text. Please enable permission in your browser settings, or try a different browser.'
        };
    }
	else if ($('body').is('.lang_au')) {
        sk_i18n = {
            ready: true,
            backlink: 'Previous',
            name: 'Full name',
            email: 'E-mail address',
            message: 'Your message',
			msgAlertCopy: '----------------------------\nATTENTION\n----------------------------\nBy closing this pop-up, you will copy your coupon code starting with ',
			msgAlertCopyFooter: '\n\nOnce the entire coupon code is copied to your clipboard, you will be redirected directly to the website where you can redeem this discount.',
			msgAlertShare: 'This link has been copied: ',
            msgNoCaptcha: 'Please indicate that you are not a robot!',
            msgContactSendTitle: 'Thanks for your message!',
            msgContactSendContent: 'Your message has been sent successfully. We will answer you as soon as possible.',
			msgWelcomeBack: "Welcome back",
			msgNewsletterAlmostThere: "you're almost there!",
			msgNewsletterConfirmationMail: "We just sent you a confirmation email (this may take a few minutes). Click on the confirmation link and you will receive interesting student discounts per email :)",
			msgNewsletterSmartStudent: "you are a smart student!",
			msgNewsletterSubscribed: "From now on you will receive interesting student discounts per email.",
            msgFetchingCode: 'Your code is being generated',
            msgFetchingCodeFailed: 'Oops! Generating code failed',
            msgFailedCopyDiscountCode: '----------------------------\nOoooops\n----------------------------\nUnfortunately, we can\'t copy the coupon code to your clipboard because your browser doesn\'t have permission to copy text. Please enable permission in your browser settings, or try a different browser.'
        };
    }	
	else if ($('body').is('.lang_es')) {
        sk_i18n = {
            ready: true,
            backlink: 'Anterior',
            name: 'Nombre completoecci',
            email: 'Tu dirón de correo electrónico',
            message: 'Tu mensaje',
			msgAlertCopy: '----------------------------\nATENCIÓN\n----------------------------\nCuando cierre esta ventana emergente, copiará su código de descuento que empieza por ',
			msgAlertCopyFooter: '\n\nUna vez que haya copiado el código de descuento en su portapapeles, será redirigido directamente a la página web donde podrá canjear el descuento',
			msgAlertShare: 'Este enlace ha sido copiado: ',
            msgNoCaptcha: 'Por favor, indique que no es un robot.',
            msgContactSendTitle: '¡Gracias por su mensaje!',
            msgContactSendContent: 'Su mensaje se ha enviado correctamente. Le responderemos lo antes posible.',
			msgWelcomeBack: "Bienvenido de nuevo",
			msgNewsletterAlmostThere: "¡ya casi está!",
			msgNewsletterConfirmationMail: "Acabamos de enviarte un correo electrónico de confirmación (puede tardar unos minutos). Haz clic en el enlace de confirmación y recibirás interesantes descuentos para estudiantes por correo electrónico :)",
			msgNewsletterSmartStudent: "¡eres un estudiante inteligente!",
			msgNewsletterSubscribed: "A partir de ahora, recibirás por correo electrónico atractivos descuentos para estudiantes.",
            msgFetchingCode: 'Se genera su código',
            msgFetchingCodeFailed: '¡Ups! Error en la generación del código',
            msgFailedCopyDiscountCode: '----------------------------\nOoooops\n----------------------------\nLamentablemente, no podemos copiar el código del cupón en su portapapeles porque su navegador no permite copiar texto. Active esta opción en la configuración de su navegador o pruebe con otro navegador.'
        };
    }
	else if ($('body').is('.lang_pl')) {
        sk_i18n = {
            ready: true,
            backlink: 'Powrót',
            name: 'Pełna nazwa',
            email: 'Adres e-mail',
            message: 'Twoja wiadomość',
			msgAlertCopy: '----------------------------\nUWAGA\n----------------------------\nZamykając to wyskakujące okienko, skopiujesz swój kod rabatowy zaczynający się od ',
			msgAlertCopyFooter: '\n\nPo skopiowaniu całego kodu rabatowego do schowka zostaniesz przekierowany bezpośrednio na stronę internetową, na której możesz zrealizować tę zniżkę.',
			msgAlertShare: 'Ten link został skopiowany: ',
            msgNoCaptcha: 'Zaznacz, że nie jesteś robotem!',
            msgContactSendTitle: 'Dziękujemy za wiadomość!',
            msgContactSendContent: 'Wiadomość została wysłana pomyślnie. Odpowiemy tak szybko, jak to możliwe.',
			msgWelcomeBack: "Witamy z powrotem",
			msgNewsletterAlmostThere: "Już prawie!",
			msgNewsletterConfirmationMail: "Właśnie wysłaliśmy Ci e-mail z potwierdzeniem (może to potrwać kilka minut). Kliknij w link potwierdzający, a otrzymasz atrakcyjne zniżki studenckie drogą mailową :)",
			msgNewsletterSmartStudent: "Jesteś mądrym uczniem!",
			msgNewsletterSubscribed: "Od teraz będziesz otrzymywać interesujące zniżki studenckie na e-mail.",
            msgFetchingCode: 'Kod jest generowany',
            msgFetchingCodeFailed: 'Ups! Generowanie kodu nie powiodło się',
            msgFailedCopyDiscountCode: '----------------------------\nUuuuups\n----------------------------\nPPurtroppo non è possibile copiare il codice sconto negli appunti perché il browser non ha l\'autorizzazione a copiare il testo. Si prega di abilitare l\'autorizzazione nelle impostazioni del browser o di provare con un altro browser.'
        };
    }
	else if ($('body').is('.lang_it')) {
        sk_i18n = {
            ready: true,
            backlink: 'Indietro',
            name: 'Nome e cognome',
            email: 'Indirizzo e-mail',
            message: 'Il vostro messaggio',
			msgAlertCopy: '----------------------------\nATTENZIONE\n----------------------------\nQuando si chiude questa finestra pop-up, si copia il codice di sconto che inizia con ',
			msgAlertCopyFooter: '\n\nUna volta copiato il codice sconto negli appunti, si verrà reindirizzati direttamente al sito web dove si potrà riscattare lo sconto',
			msgAlertShare: 'Questo link è stato copiato: ',
            msgNoCaptcha: 'Indicare che non si è un robot.',
            msgContactSendTitle: 'Grazie per il vostro messaggio!',
            msgContactSendContent: 'Il vostro messaggio è stato inviato con successo. Vi risponderemo il prima possibile.',
			msgWelcomeBack: "Bentornato",
			msgNewsletterAlmostThere: "Ci siamo quasi!",
			msgNewsletterConfirmationMail: "Ti abbiamo appena inviato un'e-mail di conferma (potrebbe volerci qualche minuto). Cliccate sul link di conferma e riceverete via e-mail gli interessanti sconti per studenti :)",
			msgNewsletterSmartStudent: "Sei uno studente intelligente!",
			msgNewsletterSubscribed: "D'ora in poi riceverete via e-mail interessanti sconti per studenti.",
            msgFetchingCode: 'Il codice viene generato',
            msgFetchingCodeFailed: 'Oops! Errore nella generazione del codice',
            msgFailedCopyDiscountCode: '----------------------------\nOoooops\n----------------------------\nPurtroppo non è possibile copiare il codice coupon negli appunti perché il browser non consente di copiare il testo. Si prega di attivare questa opzione nelle impostazioni del browser o di provare con un altro browser.'
        };
    }
	else if ($('body').is('.lang_fr')) {
        sk_i18n = {
            ready: true,
            backlink: 'Retour',
            name: 'Nom et prénom',
            email: 'Su dirección de correo electrónico',
            message: 'Votre message',
			msgAlertCopy: '----------------------------\nATTENTION\n----------------------------\nEn fermant ce pop-up, vous copierez votre code de réduction commençant par ',
			msgAlertCopyFooter: '\n\nUne fois le code de réduction copié dans votre presse-papiers, vous serez redirigé directement vers le site web où vous pourrez utiliser cette réduction.',
			msgAlertShare: 'Ce lien a été copié : ',
            msgNoCaptcha: 'Veuillez indiquer que vous n\'êtes pas un robot !',
            msgContactSendTitle: 'Merci pour votre message !',
            msgContactSendContent: 'Votre message a été envoyé avec succès. Nous vous répondrons dans les plus brefs délais.',
			msgWelcomeBack: "Bienvenue à nouveau",
			msgNewsletterAlmostThere: "vous y êtes presque !",
			msgNewsletterConfirmationMail: "Nous venons de vous envoyer un e-mail de confirmation (cela peut prendre quelques minutes). Cliquez sur le lien de confirmation et vous recevrez des réductions étudiantes intéressantes par e-mail :)",
			msgNewsletterSmartStudent: "tu es un étudiant intelligent !",
			msgNewsletterSubscribed: "Désormais, vous recevrez par e-mail des réductions intéressantes pour les étudiants.",
            msgFetchingCode: 'Votre code est généré',
            msgFetchingCodeFailed: 'Oops! La génération du code a échoué',
            msgFailedCopyDiscountCode: '----------------------------\nOoooops\n----------------------------\nMalheureusement, nous ne pouvons pas copier le code du coupon dans votre presse-papiers car votre navigateur n\'a pas l\'autorisation de copier du texte. Veuillez activer l\'autorisation dans les paramètres de votre navigateur, ou essayez un autre navigateur.'
        };
	}
    else if ($('body').is('.lang_de')) {
        sk_i18n = {
            ready: true,
            backlink: 'Zuruck',
            name: 'Vor- und Nachname',
            email: 'E-Mail-Adresse',
            message: 'Ihre Frage',
			msgAlertCopy: '----------------------------\nACHTUNG\n----------------------------\nWenn Sie dieses Pop-up-Fenster schließen, kopieren Sie Ihren Gutscheincode, der anfängt mit ',
			msgAlertCopyFooter: '\n\nSobald der vollständige Gutscheincode in Ihre Zwischenablage kopiert wurde, werden Sie direkt auf die Website weitergeleitet, auf der Sie diesen Rabatt einlösen können.',
			msgAlertShare: 'Link kopiert: ',
            msgNoCaptcha: 'Bitte geben Sie an, dass Sie kein Roboter sind!',
            msgContactSendTitle: 'Danke für deine Mail!',
            msgContactSendContent: 'Deine Nachricht wurde erfolgreich gesendet. Wir werden Ihnen so schnell wie möglich antworten.',
			msgWelcomeBack: "Willkommen zurück",
			msgNewsletterAlmostThere: " du bist fast da!",
			msgNewsletterConfirmationMail: "Wir haben Ihnen eine Bestätigungs-E-Mail geschickt (dies kann einige Minuten dauern). Klicken Sie auf den Bestätigungslink in dieser E-Mail und Sie erhalten interessante Studentenrabatte per E-Mail :)",
			msgNewsletterSmartStudent: " du bist ein kluger Student!",
			msgNewsletterSubscribed: "Ab sofort erhalten Sie interessante Studentenrabatte per E-Mail.",
            msgFetchingCode: 'Ihr Code wird generiert',
            msgFetchingCodeFailed: 'Ups! Code generieren fehlgeschlagen',
			msgFailedCopyDiscountCode: '----------------------------\nUps\n----------------------------\nLeider können wir den Gutscheincode nicht in die Zwischenablage kopieren, da dein Browser keine Berechtigung zum Kopieren von Texten hat. Bitte aktiviere die Berechtigung in den Browsereinstellungen oder versuche es mit einem anderen Browser.'
        };
    }
	else if ($('body').is('.lang_at')) {
        sk_i18n = {
            ready: true,
            backlink: 'Zuruck',
            name: 'Vor- und Nachname',
            email: 'E-Mail-Adresse',
            message: 'Ihre Frage',
			msgAlertCopy: '----------------------------\nACHTUNG\n----------------------------\nWenn Sie dieses Pop-up-Fenster schließen, kopieren Sie Ihren Gutscheincode, der anfängt mit ',
			msgAlertCopyFooter: '\n\nSobald der vollständige Gutscheincode in Ihre Zwischenablage kopiert wurde, werden Sie direkt auf die Website weitergeleitet, auf der Sie diesen Rabatt einlösen können.',
			msgAlertShare: 'Link kopiert: ',
            msgNoCaptcha: 'Bitte geben Sie an, dass Sie kein Roboter sind!',
            msgContactSendTitle: 'Danke für deine Mail!',
            msgContactSendContent: 'Deine Nachricht wurde erfolgreich gesendet. Wir werden Ihnen so schnell wie möglich antworten.',
			msgWelcomeBack: "Willkommen zurück",
			msgNewsletterAlmostThere: " du bist fast da!",
			msgNewsletterConfirmationMail: "Wir haben Ihnen eine Bestätigungs-E-Mail geschickt (dies kann einige Minuten dauern). Klicken Sie auf den Bestätigungslink in dieser E-Mail und Sie erhalten interessante Studentenrabatte per E-Mail :)",
			msgNewsletterSmartStudent: " du bist ein kluger Student!",
			msgNewsletterSubscribed: "Ab sofort erhalten Sie interessante Studentenrabatte per E-Mail.",
            msgFetchingCode: 'Ihr Code wird generiert',
            msgFetchingCodeFailed: 'Ups! Code generieren fehlgeschlagen',
            msgFailedCopyDiscountCode: '----------------------------\nUps\n----------------------------\nLeider können wir den Gutscheincode nicht in die Zwischenablage kopieren, da dein Browser keine Berechtigung zum Kopieren von Texten hat. Bitte aktiviere die Berechtigung in den Browsereinstellungen oder versuche es mit einem anderen Browser.'
        };
    }
    else {
        sk_i18n.ready = true;
    }
});
